import gql from 'graphql-tag';

import remoteItemFromProviderFragment from './remoteItemFromProviderFragment';

export const microsoftTeamsRemoteItemsPageFragment = gql`
  fragment microsoftTeamsRemoteItemsPageFragment on MicrosoftTeamsRemoteItemsPage {
    dokkioClass
    nextToken
    remoteItems {
      ...remoteItemFromProviderFragment
    }
  }
  ${remoteItemFromProviderFragment}
`;
export default microsoftTeamsRemoteItemsPageFragment;
